import React, { useContext } from 'react'
import { MetricsContext } from '../context'
import { Card, CardHeading, CardContent } from '../../../components/layout/Card'
import { valueToRiskBracket } from '../../../utils/riskConversions'
import Box from '@material-ui/core/Box'

export const RiskProfile = () => {
  return (
    <Card className='group-risk-profile'>
      <CardHeading>
        <h5> Risk profile averages </h5>
      </CardHeading>
      <CardContent>
        <RiskProfileRatings />
      </CardContent>
    </Card>
  )
}

export const RiskProfileRatings = () => {
  const { state } = useContext(MetricsContext)
  const { groupInflation, groupRiskProfiles } = state
  const { rating, capacity, tolerance, required_risk } = groupRiskProfiles
  return (
    <Box
      display='flex'
      justifyContent='space-between'
    >
      <RiskRating
        label={'Average Risk Rating'}
        value={`${rating + groupInflation}%`}
        name={valueToRiskBracket(rating)}
      />
      <RiskRating
        label={'Average Risk Capacity'}
        value={`${capacity + groupInflation}%`}
        name={valueToRiskBracket(capacity)}
      />
      <RiskRating
        label={'Average Risk Tolerance'}
        value={`${tolerance + groupInflation}%`}
        name={valueToRiskBracket(tolerance)}
      />
      <RiskRating
        label={'Average Required Risk'}
        value={`${required_risk + groupInflation}%`}
        name={valueToRiskBracket(required_risk)}
      />
    </Box>
  )
}

const RiskRating = ({ label, value, name }) =>
  <Box
    display='flex'
    flexDirection='column'
    justifyContent='center'
    alignItems='center'>
    <h5> {label} </h5>
    <h1> {value} </h1>
    <p> {name} </p>
  </Box>
